export const useIsAr = (direction) => {
  return {
    isAr: direction === 'rtl',
  };
};
